import { render, staticRenderFns } from "./PieChartNew.vue?vue&type=template&id=b3bcf850&"
import script from "./PieChartNew.vue?vue&type=script&lang=js&"
export * from "./PieChartNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports